import { render } from "./ConstructionalPraxisRecall.vue?vue&type=template&id=7736719f&scoped=true"
import script from "./ConstructionalPraxisRecall.vue?vue&type=script&lang=js"
export * from "./ConstructionalPraxisRecall.vue?vue&type=script&lang=js"

import "./ConstructionalPraxisRecall.vue?vue&type=style&index=0&id=7736719f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7736719f"]])

export default __exports__